import Desktop from './desktop'
import Mobile from './mobile'

const AuthorCard = ({
  is_mobile,
  author_name,
  author_description,
  author_image,
}) => {
  const props = {
    is_mobile: is_mobile || false,
    author_name: author_name || 'Editorial FDN',
    author_image:
      author_image ||
      'https://cdn1.iconfinder.com/data/icons/school-icons-2/512/typewriter-512.png',
    author_description: author_description || '-',
  }
  if (props.is_mobile) {
    return <Mobile {...props} />
  } else {
    return <Desktop {...props} />
  }
}

export default AuthorCard
